import React,{useState} from 'react';
export default function SimpleMsgRight(props) {
  const {msg,img } = props;
  return (
    <>
          
          <div className='ml-12  mb-3 bg-primary text-white flex text-sm p-3 rounded-2xl rounded-br-none mt-4 pb-5'>
              <div className=" ">
                <div className="h-6 w-6 bg-primary p-1.5 mr-2 rounded-full">
                  <img src={img} className='h-auto w-4'/> 
                </div>
              </div>
              <div className='flex-1'>
              {msg}
              </div>
            </div>  
    </>
  );
}